import { render } from "./BetSlipWager.vue?vue&type=template&id=1119f969&scoped=true"
import script from "./BetSlipWager.vue?vue&type=script&lang=js"
export * from "./BetSlipWager.vue?vue&type=script&lang=js"

import "./BetSlipWager.vue?vue&type=style&index=0&id=1119f969&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1119f969"]])

export default __exports__